import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Constants} from '../shared/constants';
import {HeaderFilterOption, LoadOptions} from '../shared/models/shared.model';
import {Observable} from 'rxjs';
import {
  SalonChainDataMappingModel,
  SalonChainMappingGridModel,
  SalonChainMasterGridResultModel
} from '../shared/models/salon-chain-mapping.model';
import {HeaderFilterData} from '../shared/models/product.model';

@Injectable({
  providedIn: 'root'
})
export class SalonChainMappingService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/salonchaindatamapping';

  constructor(private httpClient: HttpClient) { }

  public getSalonChainMappingGrid(param: LoadOptions): Observable<SalonChainMappingGridModel> {
	return this.httpClient
		.post<SalonChainMappingGridModel>(
		this.url + `/getSalonChainMappingGrid`, param,
		{ headers: this.headers }
		);
  }

  public getSalonChainMasterGrid(param: LoadOptions): Observable<SalonChainMasterGridResultModel> {
	return this.httpClient
		.post<SalonChainMasterGridResultModel>(
		this.url + `/getSalonChainMasterGrid`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersSalonChainMappingGrid(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersSalonChainMappingGrid`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersSalonChainMasterGrid(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersSalonChainMasterGrid`, param,
		{ headers: this.headers }
		);
  }

  public mappingAction(param): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/mappingAction', param,
		{ headers: this.headers }
		);
  }

  public createOrModifySalonChainMasterData(data: SalonChainDataMappingModel) {
	return this.httpClient
		.post<any>(
		this.url + '/createOrModifySalonChainMasterData', data,
		{ headers: this.headers }
		);
  }
}
